import { useCallback } from 'react';
import { get, isArray } from 'lodash';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { downloadAllDocuments } from '../../actions/documents';
import { downloadAllDefects } from '../../actions/defects';
import { useLegDocumentNotifications } from '../../selectors/documents';
import { useLegDefectNotifications } from '../../selectors/defects';
import { getCurrentLeg, getCurrentLegCrewType, getCurrentLegInfo } from '../../selectors/screen';
import { ContentType, ContentTypes } from './constants';
import { useLanguage } from '../hooks/useLanguage/useLanguage';

export const useAttachmentsPage = () => {
    const { isEng} = useLanguage();
    const {
        contentType,
        currentLegInfo = '',
        plnName,
    } = useSelector((state) => {
        const leg = getCurrentLeg(state) || {};
        const currentLegInfo = getCurrentLegInfo(state);
        const contentType = state.screen?.attachmentContentType;

        return {
            contentType,
            currentLegInfo: isArray(currentLegInfo) ? currentLegInfo[Number(isEng)] : currentLegInfo,
            plnName: get(leg, 'plnName', ''),
        };
    }, shallowEqual);

    const crewType = useSelector(getCurrentLegCrewType);
    const { title = '', component: Component } = ContentTypes[contentType] || {};

    const documentWithWarning = useLegDocumentNotifications();
    const limitationWithWarning = useLegDefectNotifications();
    const attachmentWithWarning =
        (contentType === ContentType.DOCUMENTS && documentWithWarning) ||
        (contentType === ContentType.LIMITATIONS && limitationWithWarning) ||
        [];

    const dispatch = useDispatch();

    const handleDowloadAllClick = useCallback(() => {
        if (contentType === ContentType.DOCUMENTS) {
            dispatch(downloadAllDocuments(attachmentWithWarning.map((item) => item.id)));
        } else if (contentType === ContentType.LIMITATIONS) {
            dispatch(downloadAllDefects(attachmentWithWarning.map((item) => item.id)));
        }
    }, [attachmentWithWarning, contentType]);

    return { Component, contentType, crewType, currentLegInfo, attachmentWithWarning, plnName, title, handleDowloadAllClick };
};
